module.exports = __webpack_public_path__ + "static/media/socicon.dbb2486d.eot";